<template>
  <RygenDomainSwitcherModal
    v-if="targetDomain"
    :visible="visible"
    :target-domain="targetDomain"
    :target-domain-branding="targetDomainBranding"
    @confirmed="confirmDomainChange"
    @canceled="onCancel"
  />
</template>

<script lang="ts" setup>
import { computed, toRefs, watch } from 'vue';
import { useRouter } from 'vue-router';

import { DomainBranding } from '@rygen/rygen-ui/model';

import { useCurrentUserStore } from '@/stores/CurrentUser';
import { useDomainStore } from '@/stores/Domain';

import RygenDomainSwitcherModal from '@rygen/rygen-ui/components/domain/DomainSwitcherModal.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false,
  },
});
const { visible } = toRefs(props);

const { confirmDomainChange, revertDomainChange, targetDomain } =
  useCurrentUserStore();
const { domainBrandings, loadDomainBranding } = useDomainStore();
const router = useRouter();

const targetDomainBranding = computed(
  () =>
    (targetDomain.value?.id
      ? domainBrandings.value[targetDomain.value.id]?.data
      : undefined) ?? new DomainBranding(),
);

const onCancel = () => {
  revertDomainChange();
  router.replace({ name: 'home' });
};

watch(
  targetDomain,
  (newVal) => {
    if (newVal?.id) {
      void loadDomainBranding(newVal.id);
    }
  },
  { immediate: true },
);
</script>
